import { render, staticRenderFns } from "./SearchByPicture.vue?vue&type=template&id=f8316e5a&scoped=true&"
import script from "./SearchByPicture.vue?vue&type=script&lang=js&"
export * from "./SearchByPicture.vue?vue&type=script&lang=js&"
import style0 from "./SearchByPicture.vue?vue&type=style&index=0&id=f8316e5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8316e5a",
  null
  
)

export default component.exports